import { Attachment } from "../../domain/model/Attachment";
import {
  AccessToken,
  LoginAnonymouslyRequestModel,
  Message,
} from "../../domain/model/Auth";
import { CategoryEntity } from "../../domain/model/Category";
import {
  Game,
  GiveRatingRequestModel,
  UpdateGameRequestModel,
} from "../../domain/model/Game";
import {
  Question,
  Answer,
  GetRandomQuestionRequestModel,
} from "../../domain/model/Question";
import { Player } from "../../domain/model/User";
import { ApiService } from "../api/ApiService";
import { Response } from "../api/Response";
import { API_ENDPOINTS } from "../constant/ApiConstants";
import NetworkApi from "./NetworkApi";

export default class NetworkApiImpl implements NetworkApi {
  apiService: ApiService;

  constructor(apiService: ApiService) {
    this.apiService = apiService;
  }
  // auth
  loginAnonymously(
    body: LoginAnonymouslyRequestModel,
  ): Promise<Response<AccessToken>> {
    return this.apiService.post<AccessToken>(
      API_ENDPOINTS.LOGIN_ANONYMOUSLY,
      body,
    );
  }

  // file
  uploadFile(fileFormData: FormData): Promise<Response<Attachment>> {
    return this.apiService.post<Attachment>(
      API_ENDPOINTS.UPLOAD_FILE,
      fileFormData,
    );
  }

  // players
  getCurrentUserInfo(): Promise<Response<Player>> {
    return this.apiService.get<Player>(API_ENDPOINTS.PLAYERS);
  }

  // catgories
  getCategories(): Promise<Response<Array<CategoryEntity>>> {
    var url = API_ENDPOINTS.CATEGORIES;
    return this.apiService.get<Array<CategoryEntity>>(url);
  }

  // questions
  getRandomQuestion(
    getRandomQuestionRequestModel: GetRandomQuestionRequestModel,
  ): Promise<Response<Question>> {
    return this.apiService.post<Question>(
      API_ENDPOINTS.QUESTIONS + API_ENDPOINTS.GET_RANDOM_QUESTION,
      getRandomQuestionRequestModel,
    );
  }
  giveAnswer(
    questionId: string,
    isCorrect: boolean,
  ): Promise<Response<Message>> {
    return this.apiService.post<Message>(
      `${API_ENDPOINTS.QUESTIONS}/${questionId}${API_ENDPOINTS.GIVE_ANSWER}`,
      { isCorrect },
    );
  }

  // answers
  getAnswerByQuestionId(questionId: string): Promise<Response<Answer>> {
    return this.apiService.get<Answer>(
      API_ENDPOINTS.ANSWERS + API_ENDPOINTS.QUESTION_ID + "/" + questionId,
    );
  }
  getAnswer(id: string): Promise<Response<Answer>> {
    return this.apiService.get<Answer>(API_ENDPOINTS.ANSWERS + "/" + id);
  }

  // games
  createGame(): Promise<Response<Game>> {
    return this.apiService.post<Game>(API_ENDPOINTS.GAMES, {});
  }
  updateGame(model: UpdateGameRequestModel): Promise<Response<Message>> {
    return this.apiService.put<Message>(
      API_ENDPOINTS.GAMES + "/" + model.id,
      model,
    );
  }
  giveRatingToGame(
    gameId: string,
    giveRatingModel: GiveRatingRequestModel,
  ): Promise<Response<Message>> {
    return this.apiService.post<Message>(
      `${API_ENDPOINTS.GAMES}/${gameId}${API_ENDPOINTS.GIVE_RATING}`,
      giveRatingModel,
    );
  }
}
